import * as angular from 'angular';

interface SelectorInfo {
  icon: string;
  link: string;
  name: string;
  provider?: string;
  vendor?: string;
  view?: string;
}

class SelectorItemController {
  private selectorInfo: SelectorInfo;
  private flowFromParams: string;

  static $inject = [];
  constructor() {}
}

const SelectorItemComponent: angular.IComponentOptions = {
  controller: SelectorItemController,
  controllerAs: 'ctrl',
  bindings: {
    selectorInfo: '<',
    flowFromParams: '<',
  },
  template: `
    <a ng-if="!ctrl.flowFromParams" class="selector-item-link" ng-href="{{ctrl.selectorInfo.link}}">
      <div class="selector-item-container">
        <div class="individual-selector-name">{{ctrl.selectorInfo.name}}</div>
        <div class="selection-arrow">&rarr;</div>
      </div>
    </a>
    <a ng-if="ctrl.flowFromParams" class="selector-item-link" ng-href="{{ctrl.selectorInfo.link}}?flow={{ctrl.flowFromParams}}">
      <div class="selector-item-container">
        <div class="individual-selector-name">{{ctrl.selectorInfo.name}}</div>
        <div class="selection-arrow">&rarr;</div>
      </div>
    </a>`,
};

angular.module('mode.components').component('selectorItem', SelectorItemComponent);
